export default {
  sm: `
    데이터센터 각 춘천은 더 안전하고 정확한 기술력을 
    바탕으로 자연과 함께 만드는 에너지 효율을 목표로 
    합니다.
  `,
  md: `
    데이터센터 각 춘천은 더 안전하고 
    정확한 기술력을 바탕으로 자연과 함께 만드는 
    에너지 효율을 목표로 합니다.
  `,
  lg: `
    데이터센터 각 춘천은 더 안전하고 정확한 기술력을 바탕으로 
    자연과 함께 만드는 에너지 효율을 목표로 합니다.
  `
};
